export default "__VITE_ASSET__DVHW5aAB__"